// extracted by mini-css-extract-plugin
export default {"dialogText":"Dialog_dialogText__uruvg"};